import React, { useState, useEffect } from "react";
import Icon from "@mdi/react";
import { mdiFolderHomeOutline, mdiFileEditOutline, mdiAccountHardHat, mdiPencil, mdiTrashCan } from '@mdi/js';
import { getGroupSkill } from "../../interpreter/groupSkill";

export const CategorieList = ({ openModal , refresh}) => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchCategories = async () => {
            try {
                const response = await getGroupSkill();

                const categoriesData = response?.data?.getServiceCategory_?.category;
                if (!categoriesData || !Array.isArray(categoriesData)) {
                    throw new Error("Datos de categorías no válidos");
                }

                const formattedData = categoriesData.map(cat => ({
                    id: cat.id ?? `temp-cat-${cat.name}`,
                    name: cat.nameCategory || "Sin nombre",
                    photo: cat.photo || null,
                    subcategories: (cat.skill || []).map(skill => ({
                        id: skill.id_skill ?? `temp-skill-${skill.name}`,
                        name: skill.name || "Habilidad sin nombre",
                        photo: skill.photo || null
                    }))
                }));

                setCategories(formattedData);
            } catch (err) {
                setError(err.message);
                console.error("Error en fetchCategories:", err);
            } finally {
                setLoading(false);
            }
        };

    useEffect(() => {
        fetchCategories();
    },[refresh]);

    if (loading) return <div className="text-center py-8">Cargando categorías...</div>;
    if (error) return <div className="text-red-500 text-center py-8">{error}</div>;

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {categories?.map((category) => (
                <div key={category.id} className="bg-white shadow-md rounded-lg p-4 relative">
                    <button
                        className="absolute top-2 right-2 bg-blue-500 hover:bg-blue-400 text-white py-1 px-1 rounded-lg"
                        title="Editar"
                        onClick={() => openModal('editCat', category)}
                        ><Icon path={mdiPencil} size={0.8} />
                    </button>
                    <div className="flex items-center gap-3 mb-3">
                        {category.photo ? (
                            <img src={category.photo} alt={category.name} className="w-20 h-20 rounded-2xl" />
                            
                        ) : (
                            <Icon path={mdiFolderHomeOutline} size={1.5} className="text-purple-500" />
                        )}
                        <h3 className="text-lg font-bold">{category.name}</h3>
                    </div>

                    <div className="mt-4">
                        <div className="flex items-center gap-2 mb-2">
                            <Icon path={mdiAccountHardHat} size={1.3} className="text-black bg-gray-200 rounded-full p-1" />
                            <h4 className="text-sm font-semibold text-blue-600">Habilidades:</h4>
                            <button
                                className="bg-blue-500 hover:bg-blue-400 text-white p-1 rounded-md ml-auto"
                                title="Editar"
                                onClick={() => openModal('editHab', category)}
                            ><Icon path={mdiFileEditOutline} size={0.8} />
                            </button>
                        </div>
                        <ul className="space-y-1">
                            {category.subcategories?.map((sub) => (
                                <li key={sub.id} className="flex items-center gap-2">
                                    {sub.photo && <img src={sub.photo} alt={sub.name} className="w-9 h-9 rounded-full" />}
                                    <span className="text-sm">{sub.name}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            ))}
        </div>
    );
};